









































































import {Component, Prop, Vue} from "vue-property-decorator";
import MillisecondDatePicker from "@/shared/components/MillisecondDatePicker/index.vue";
import UploadImage from "@/shared/components/UploadImage/Index.vue";
import {FormModel} from "ant-design-vue";
import InputTimeCustom from "@/shared/components/InputTimeCustom/index.vue";
import InputDateCustom from "@/shared/components/InputDateCustom/index.vue";
import AInputBarCode from "@/shared/components/InputBarCode/index.vue";
import ReportDeliveryExcel from "@/modules/reportdelivery/Form/Excel/index.vue";
import {ReportDeliveryStore} from "@/modules/reportdelivery/store";
import {assignValueToForm} from "@/shared/services/helper/utils";

const form = {
    rowGuid: "",
    ladingCode: "",
    receiver: "",
    reportDeliveryDate: "",
    reportDeliveryTime: "",
    note: "",
    image: "",
    imageUrl: ""
};
@Component({
    name: "FormUpdateReportDelivery",
    components: {
        ReportDeliveryExcel,
        AInputBarCode, InputDateCustom, InputTimeCustom, UploadImage, MillisecondDatePicker
    }
})
export default class extends Vue {
    @Prop()
    readonly id!: string;
    reportDeliveries = [] as any;
    isSubmitting = false;
    private form = {...form};
    private rules = {
        id: [{required: false, message: "", trigger: "change"}],
        receiver: [{required: true, message: "Nhập tên người nhận", trigger: "change"}],
        reportDeliveryTime: [{required: true, message: "Nhập giờ nhận", trigger: "change"}],
        reportDeliveryDate: [{required: true, message: "Nhập ngày nhận", trigger: "change"}]
    }
    
    async created() {
        try {
            const data = await ReportDeliveryStore.singleReportDelivery(this.id)
            this.form = assignValueToForm(this.form, {...data});
            this.form.ladingCode = data.billLading?.ladingCode || "";
            this.form.image = data.images[0];
            this.form.imageUrl = data.imageUrls[0];
        } catch (e) {
            this.$notification.error({
                message: "Thất bại",
                description: `${e.response?.data?.message || "Đã có lỗi xảy ra"}`
            })
        }
    }
    
    private updateReportDelivery() {
        (this.$refs.formSite as FormModel).validate(async valid => {
            try {
                console.log(this.form)
                await ReportDeliveryStore.updateReportDelivery(this.form)
                this.$notification.success({
                    message: "Thành công",
                    description: `${this.id ? 'Sửa' : 'Tạo'} báo phát thành công`
                });
                this.$router.push({name: "listReportDelivery"});
            } catch (e) {
                this.$notification.error({
                    message: "Thất bại",
                    description: `${e.response?.data?.message || `${this.id ? 'Sửa' : 'Tạo'} báo phát thất bại`}`
                })
            }
        })
    }
    
}
